import Vue from 'vue'
import Vuetify, { colors } from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
// import 'vuetify/dist/vuetify.min.css'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify, {
	directives: {
		Ripple
	}
})

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
      themes: {
          light: {
              primary: '#6d5da4',
              secondary: '#6d5cae',
              accent: '#10cfbd',
              info: '#007bff',
            colors: {
              primary: '#6d5da4',
              secondary: '#6d5cae',
              accent: '#10cfbd',
              info: '#007bff',
            },
			  anchor: '#8A7DBE',
          },
      },
  },
})
